import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/cart";
import { perBagMoney, useBestPerBag } from "@/lib/shop";

export const MobileBar = () => {
  const [show, setShow] = useState(false);
  const { count, setOpen } = useCart();
  const perBag = useBestPerBag();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = show && pathname !== "/shop" && pathname !== "/build";
  return (
    <AnimatePresence>
      {visible && (
        <motion.div data-testid="sticky-mobile-buy-bar" initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }} transition={{ type: "spring", damping: 22 }}
          className="md:hidden fixed bottom-3 inset-x-3 z-40 flex gap-2 rounded-full bg-white/90 backdrop-blur-xl border border-[#1B1530]/10 shadow-xl p-2">
          <Link to="/shop" data-testid="mobile-quick-shop-button" className="flex-1 h-12 rounded-full bg-[#FF5A5F] text-white font-bold text-sm grid place-items-center">
            {`Shop${perBag ? ` · from ${perBagMoney(perBag)}/bag` : ""}`}
          </Link>
          <button data-testid="mobile-cart-button" onClick={() => setOpen(true)} className="relative h-12 w-12 rounded-full bg-[#1B1530] text-white grid place-items-center" aria-label="Open cart">
            <ShoppingBag className="h-5 w-5" />
            {count > 0 && <span className="absolute -top-1 -right-1 h-5 min-w-5 px-1 rounded-full bg-[#FFB21A] text-[#1B1530] text-[11px] font-bold grid place-items-center">{count}</span>}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
